import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="bg-ivory min-h-[70vh] flex items-center" data-testid="not-found">
      <div className="container-px max-w-[1400px] mx-auto py-20 md:py-32 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <div className="overline mb-6">Error 404</div>
          <h1 className="h-display text-5xl md:text-7xl text-navy mb-7">
            This page is unavailable.
          </h1>
          <p className="body-lg text-charcoal/75 mb-10 max-w-xl">
            The page you are looking for cannot be found. It may have been moved or no longer exists.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" data-testid="not-found-home" className="btn-primary">Return Home</Link>
            <Link to="/expertise" data-testid="not-found-expertise" className="btn-outline">Explore Expertise</Link>
          </div>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <div className="font-serif text-[140px] md:text-[200px] text-navy/10 leading-none text-right">
            404
          </div>
        </div>
      </div>
    </section>
  );
}
